import { ValidationErrors } from 'final-form';
import arrayMutators from 'final-form-arrays';
import React, { ReactNode } from 'react';
import { Form } from 'react-final-form';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { LoginProjectConfiguration } from '../../../api';
import { usePaths } from '../../../routes/routesHelper';
import { VerticalHorizontalCenterBlock } from '../../../styled';
import SettingsFrame from '../../MainSettings/SettingsTabs';
import { FormFooter, HeaderTitle, Preloader } from '../index';
import { ContentForm, FormWrapper } from './style';

type Props = RouteComponentProps & {
  currentProjectType: string | null;
  currentProjectFetching: boolean;
  currentUpdateFetching: boolean;
  children?: JSX.Element | string | null;
  title: string;
  description?: string;
  notification?: string | ReactNode;
  submitError?: boolean;
  currentProject: LoginProjectConfiguration;
  initialValues?: Record<string, unknown>;
  validate?: (values: LoginProjectConfiguration) => ValidationErrors | Promise<ValidationErrors>;
  onSubmit: (el: LoginProjectConfiguration) => void;
};

const ConfigurationsSample = ({
  currentProject,
  currentProjectType,
  currentProjectFetching,
  currentUpdateFetching,
  children,
  initialValues,
  title,
  submitError,
  description,
  notification,
  validate,
  onSubmit,
  history
}: Props): JSX.Element | null => {
  const { navigationPath } = usePaths();

  const backToNavigation = () =>
    currentProject.id && history.push({ pathname: navigationPath(currentProject.id) });

  if (currentProjectFetching) {
    return (
      <SettingsFrame projectId={currentProject.id} projectType={currentProjectType}>
        <VerticalHorizontalCenterBlock>
          <Preloader />
        </VerticalHorizontalCenterBlock>
      </SettingsFrame>
    );
  }

  return (
    <SettingsFrame projectId={currentProject.id} projectType={currentProjectType}>
      <Form
        keepDirtyOnReinitialize
        onSubmit={onSubmit}
        initialValues={initialValues || currentProject}
        mutators={{
          ...arrayMutators
        }}
        validate={validate}>
        {({ handleSubmit, pristine }) => (
          <>
            <ContentForm>
              <HeaderTitle
                title={title}
                subtitle={description}
                notification={notification}
                notificationMargin={8}
              />
              <FormWrapper>{children}</FormWrapper>
            </ContentForm>

            <FormFooter
              onSubmit={handleSubmit}
              onCancel={backToNavigation}
              fetching={currentUpdateFetching}
              error={submitError}
              disabled={pristine}
            />
          </>
        )}
      </Form>
    </SettingsFrame>
  );
};

export default withRouter(ConfigurationsSample);
